import { FunctionComponent } from 'react';

type ListIconProps = {
  width?: number | string;
  height?: number | string;
  active?: boolean;
};

const ListIcon: FunctionComponent<ListIconProps> = ({
  width = 34,
  height = 34,
  active = false,
}) => {
  const circleFill = active ? '#561BDC' : '#FAFAFA';
  const strokeColor = active ? '#EDEDED' : '#1A1A1A';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 34 34"
    >
      <g transform="translate(-983 -1160)">
        <circle
          cx="17"
          cy="17"
          r="17"
          transform="translate(983 1160)"
          fill={circleFill}
        />
        <g transform="translate(991 1168.409)">
          <g fill="none" stroke={strokeColor} strokeWidth="1.2">
            <rect width="18" height="17.182" rx="1" stroke="none" />
            <rect
              x="0.6"
              y="0.6"
              width="16.8"
              height="15.982"
              rx="0.4"
              fill="none"
            />
          </g>
          <line
            x2="15.545"
            transform="translate(1.227 5.727)"
            fill="none"
            stroke={strokeColor}
            strokeLinecap="round"
            strokeWidth="1.2"
          />
          <line
            x2="15.545"
            transform="translate(1.227 11.455)"
            fill="none"
            stroke={strokeColor}
            strokeLinecap="round"
            strokeWidth="1.2"
          />
        </g>
      </g>
    </svg>
  );
};

export default ListIcon;
